import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// img
import u1 from "../../../../Assets/images/i1.png";
import Select from "react-select";
import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getMailTemplate_Details,
  mailTemplates_Update,
} from "../../../../store/actions";

const EmailTemp = () => {
  const [editorData, setEditorData] = useState("");

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [state, setState] = useState({
    emailTemplateId: "",
    emailTemplatedata: "",
    title: "",
    body: "",
    emailTitle: "",
    adminEmailInfo: "",
  });

  const mailTemplatesData = useSelector(
    (s) => s.Setting?.getMailTemplates?.data
  );

  const selectOptions = mailTemplatesData?.map(({ _id, title }) => ({
    value: _id,
    label: title,
  }));

  const handleDropDown = (e) => {
    // let fvalue = e.target.value;
    var selectedTemplate = mailTemplatesData.filter((element) => {
      return element._id === e.value;
    });
    setState((pre) => ({
      ...pre,
      // selectedValue: e.target.value,
      emailTitle: selectedTemplate[0].emailTitle,
      adminEmailInfo: selectedTemplate[0].adminEmailInfo,
      body: selectedTemplate[0].body,
      title: selectedTemplate[0].title,
      emailTemplatedata: {
        value: selectedTemplate[0]._id,
        label: selectedTemplate[0].title,
      },
      emailTemplateId: selectedTemplate[0]._id,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const callBack = (response) => {
      if (response.status == "success") {
        toast.success(response.message);
        navigate("/configuration/email-template");
      } else {
        toast.error(response.message);
      }
    };
    delete state.emailTemplatedata;
    dispatch(mailTemplates_Update(state, callBack));
  };

  useEffect(() => {
    dispatch(getMailTemplate_Details());
  }, []);

  return (
    <>
      <section className="position-relative py-5 configuration">
        <Container>
          <Row className="justify-content-center">
            <Col lg="9" className="my-2">
              <Form onSubmit={handleSubmit}>
                <div className="formWrpper px-sm-4 box p-3 pb-5">
                  <Row>
                    <Col lg={6} md={12}>
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        SELECT EMAIL TEMPLATES
                      </label>
                      <Select
                        className={"bg-transparent"}
                        classNamePrefix="rental"
                        options={selectOptions}
                        value={state?.emailTemplatedata}
                        onChange={handleDropDown}
                        styles={{
                          container: (baseStyles) => ({
                            ...baseStyles,
                            width: "100%",
                          }),
                          control: (baseStyles) => ({
                            ...baseStyles,
                            backgroundColor: "transparent",
                            borderRadius: "5px",
                          }),
                        }}
                      />
                    </Col>
                    <Col md="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        EMAIL TITLE
                      </label>
                      <input
                        type="text"
                        value={state.emailTitle}
                        name="emailTitle"
                        onChange={handleChange}
                        className="form-control bg-white"
                      />
                    </Col>
                    <Col md="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Content
                      </label>
                      <CKEditor
                        data={state.body}
                        editor={ClassicEditor}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setState((prevState) => ({
                            ...prevState,
                            body: data,
                          }));
                        }}
                        onBlur={(event, editor) => {
                          // console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          // console.log("Focus.", editor);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="btnWrpper mt-4 text-center">
                  <Button
                    type="submit"
                    className="d-inline-flex h-auto align-items-center justify-content-center commonBtn px-5"
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default EmailTemp;
